import * as React from 'react';
export const linearSvg = React.forwardRef(function linearSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5E6AD2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.294 18.765c-.053-.227.218-.37.383-.205l8.763 8.763c.165.165.022.436-.205.383a12.03 12.03 0 0 1-8.94-8.94ZM4 15.253a.237.237 0 0 0 .07.183L16.564 27.93a.237.237 0 0 0 .183.07c.568-.036 1.126-.11 1.67-.223a.233.233 0 0 0 .115-.395L4.618 13.468a.233.233 0 0 0-.395.114A12.018 12.018 0 0 0 4 15.253Zm1.01-4.124a.238.238 0 0 0 .05.264L20.607 26.94c.07.07.174.09.264.05.428-.19.844-.406 1.244-.644a.236.236 0 0 0 .044-.37L6.025 9.841a.236.236 0 0 0-.37.044c-.238.4-.453.816-.644 1.244Zm2.028-2.791a.237.237 0 0 1-.01-.325A11.976 11.976 0 0 1 15.987 4C22.623 4 28 9.378 28 16.012c0 3.561-1.55 6.76-4.013 8.96a.237.237 0 0 1-.325-.01L7.038 8.338Z',
      fill: '#fff',
    }),
  );
});
linearSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var linear = {
  category: 'brand',
  colorable: false,
  name: 'linear',
  svg: linearSvg,
};
